import { Injectable } from '@angular/core';

import {
  GlobalApiService,
  GlobalConstantsWebservice,
  GlobalFunctions,
  GlobalSessionData
} from 'globales-projekt-angular';
import { Observable, retry, catchError } from 'rxjs';
import { UserBetrieb } from '../data/user/user-betrieb.model';
import { Flaechenquellart } from '../data/ws/flaechenquellart.model';
import { Gebietskategorie } from '../data/ws/gebietskategorie.model';
import { MinderungsmassnahmeFlaeche } from '../data/ws/minderungsmassnahme-flaeche.model';
import { MinderungsmassnahmeTierkategorie } from '../data/ws/minderungsmassnahme-tierkategorie.model';
import { Tierart } from '../data/ws/tierart.model';
import { Tierkategorie } from '../data/ws/tierkategorie.model';
import { TkHvGeruchsemission } from '../data/ws/tk-hv-geruchsemission.model';
import { WindRichtlinienab } from '../data/ws/wind-richtlinienab.model';
import { ConstantsWebservice } from '../immutable/constants-webservice';
import { UserWindRichtlinienab } from '../data/user/user-wind-richtlinienab.model';
import { ErgebnisBetrieb } from '../data/ws/ergebnis-betrieb.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService extends GlobalApiService {
  getFlaechenquellarten(): Observable<Flaechenquellart[]> {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.GET_FLAECHENQUELLARTEN;

 
    return this.http
      .get<Flaechenquellart[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getGebietskategorien(): Observable<Gebietskategorie[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_GEBIETSKATEGORIEN;
    return this.http
      .get<Gebietskategorie[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getTkHvGeruchsemissionen(): Observable<TkHvGeruchsemission[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.GET_TK_HV_GERUCHSEMISSIONEN;
    return this.http
      .get<TkHvGeruchsemission[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getMinderungsmassnahmenFlaechen(): Observable<MinderungsmassnahmeFlaeche[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.GET_MINDERUNGSMASSNAHMEN_FLAECHEN;
    return this.http
      .get<MinderungsmassnahmeFlaeche[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getMinderungsmassnahmenTierkategorien(): Observable<
    MinderungsmassnahmeTierkategorie[]
  > {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.GET_MINDERUNGSMASSNAHMEN_TIERKATEGORIEN;
    return this.http
      .get<MinderungsmassnahmeTierkategorie[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getTierarten(): Observable<Tierart[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_TIERARTEN;
    return this.http
      .get<Tierart[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getTierkategorien(): Observable<Tierkategorie[]> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_TIERKATEGORIEN;
    return this.http
      .get<Tierkategorie[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getWindRichtlinienab(): Observable<
    WindRichtlinienab[]
  > {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.GET_WINDHAEUFIGKEIT_RICHTLINIENABSTAENDE;
    return this.http
      .get<WindRichtlinienab[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postErgebnisBetrieb(body: UserBetrieb): Observable<ErgebnisBetrieb> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_ERGEBNIS_BETRIEB;
    return this.http
      .post<ErgebnisBetrieb>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postDownloadExcel(body: UserBetrieb): Observable<Blob> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + GlobalConstantsWebservice.POST_ERGEBNISSE_EXCEL;

    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postDownloadPdf(body: UserBetrieb): Observable<Blob> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl + GlobalConstantsWebservice.POST_ERGEBNISSE_PDF;

    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postPicAbstand(body: UserBetrieb): Observable<Blob> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_PIC_ABSTAND;

    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postPicWind(body: UserBetrieb): Observable<Blob> {
    let serviceUrl: string =
      GlobalSessionData.baseUrl +
      ConstantsWebservice.POST_PIC_WIND;

    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postDownloadCsvWinddaten(body: UserWindRichtlinienab[]): Observable<Blob> {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.POST_DOWNLOAD_CSV_WINDDATEN;
    
    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );    
  }
}
